import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import RawmaterialFilterCriteria from './RawmaterialFilterCriteria'
import RawmaterialList from './RawmaterialList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './RawmaterialAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setRawmaterialDashboardRawmaterialList } from '../../store/slice/PharmaSlice';

export default function RawmaterialListView({setShowEdit,setRawmaterialId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.rawmaterialDashboard);   

    const [filteredRawmaterialList, setFilteredRawmaterialList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { rawmaterialDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (rawmaterialDashboard.rawmaterialList.length>-1){
        setFilteredRawmaterialList(rawmaterialDashboard.rawmaterialList);
        transformToCardFormat(rawmaterialDashboard.rawmaterialList, setCardList);
      }
    },[rawmaterialDashboard.rawmaterialList])

    useEffect(()=>{
          transformToCardFormat(filteredRawmaterialList, setCardList);
      },[filteredRawmaterialList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredRawmaterialList(rawmaterialDashboard.rawmaterialList);
            transformToCardFormat(rawmaterialDashboard.rawmaterialList, setCardList);

        } else {
            setFilteredRawmaterialList(
                rawmaterialDashboard.rawmaterialList
                    .filter(rawmaterial=> rawmaterial.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(rawmaterialDashboard.filteredRawmaterialList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <RawmaterialList
                    setShowEdit={setShowEdit}
                    setRawmaterialId = {setRawmaterialId}
                    tableList={filteredRawmaterialList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}